import { actions } from '..';
import * as api from '../../api';
import * as apiQueue from '../../api/queue-control';
import { FacebookComment, FacebookPost } from '../../model';
import { all } from 'async-saga';
import { takeEvery } from '../tools/async-saga-types';

const fetchFacebookPostsRequest = takeEvery(actions.fetchFacebookPostsRequest, async function (ctx, { key, queueId }) {
  const request = await apiQueue.facebookPostsGet(key, queueId)
  const userId = request.posts[0].userId
  const userName = request.posts[0].userName
  //userName can be '' as the database hasn't been updated yet

  const posts = request.posts.map(p => {
    return {
      postId: p.postId,
      createdAtUtc: api.parseMsDate(p.createdAtUtc),
      type: p.type,
      userId: p.userId,
      userName: p.userName,
      text: p.text,
      linkUrl: p.linkUrl,
      linkPicture: p.linkPicture,
      linkName: p.linkName,
      linkCaption: p.linkCaption,
      linkDescription: p.linkDescription,
      linkTitle: p.linkTitle,
      pageId: p.pageId,
      unRead: p.unRead,
      comments: !p.comments ? [] : p.comments.map(c => {
        return {
          commentId: c.commentId,
          createdAtUtc: api.parseMsDate(c.createdAtUtc),
          userId: c.userId,
          userName: c.userName,
          text: c.text,
          postId: c.postId,
          parentCommentId: c.parentCommentId,
          unRead: c.unRead,
          extensionId: c.extensionId,
          attachmentType: c.attachmentType,
          attachmentUrl: c.attachmentUrl,
          attachmentTitle: c.attachmentTitle,
          attachmentDescription: c.attachmentDescription,
          attachmentImage: c.attachmentImage,
          replies: !c.replies ? [] : c.replies.map(r => {
            return {
              commentId: r.commentId,
              createdAtUtc: api.parseMsDate(r.createdAtUtc),
              userId: r.userId,
              userName: r.userName,
              text: r.text,
              postId: r.postId,
              parentCommentId: r.parentCommentId,
              unRead: r.unRead,
              extensionId: r.extensionId,
              attachmentType: r.attachmentType,
              attachmentUrl: r.attachmentUrl,
              attachmentTitle: r.attachmentTitle,
              attachmentDescription: r.attachmentDescription,
              attachmentImage: r.attachmentImage,
              replies: [],
            } as FacebookComment
          }),
        } as FacebookComment

      }),
    } as FacebookPost
  })

  ctx.dispatch(actions.fetchFacebookPostsResponse(key, userId, userName, posts, request.page))
})

export default all(
  fetchFacebookPostsRequest,
)
